import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="w-full py-6 mt-auto">
      <div className="container flex items-center justify-center text-sm text-muted-foreground">
        <p>
          © {new Date().getFullYear()}{" "}
          <Link 
            to="https://disturbedmediagroup.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-primary transition-colors duration-200"
          >
            Disturbed Media Group
          </Link>
          . All rights reserved.
        </p>
      </div>
    </footer>
  );
}